<div class="cancel-option">
    <div class="credit-heading">
        <h4>Payment Refund</h4>
        <div class="close-icon">
            <img src="../../../../assets/images/export-close.svg" alt="Close" (click)="closeDialog()" />
        </div>
    </div>
    <div *ngIf='showError' class="pass-err">{{errorText}}.</div>
    <form [formGroup]="refundForm" (ngSubmit)="onSubmit()">
        <div class="cancel-listing">
            <h5>Refunds typically take 5–10 business days to appear on the customer’s statement. This process does not
                impact the status of the booking.</h5>
            <div class="radio-btn-outer">

<div class="single-dropdown date-outer">
                    <label for="refundAmount">Amount to be refunded</label>
                    <div class="custom-select2 custom-date-calender" appendTo="body">
                        <input type="text" id="refundAmount" formControlName="refundAmount"
                            (keypress)="onlyNumber($event)" (input)="formatValue($event)" (blur)="validateDecimal($event)"  pInputText />
                    </div>

                </div>
                <div class="single-dropdown date-outer">
                    <label for="cancellationReason">Reason<span class="custom-star">*</span></label>
                    <div class="custom-select2 custom-date-calender" appendTo="body">
                        <p-dropdown [appendTo]="'body'" id="cancellationReason" formControlName="cancellationReason"
                            [options]="cancellationReason" [placeholder]="'Select Reason'" optionLabel="reason"
                            optionValue="id" optionValue="value">
                            <ng-template let-option pTemplate="item">
                                <span class="dropdown-option">
                                    {{ option.reason }}
                                </span>
                            </ng-template>
                        </p-dropdown>
                        <img src="assets/images/fill-dropdown.svg" alt="" />
                    </div>
                </div>

<div class="single-textarea">
                    <textarea id="additional-comments" formControlName="additionalComments" maxlength="512" rows="4"
                        placeholder="Additional Note"></textarea>
                </div>

</div>
        </div>
        <div class="continue-btn">
            <p-button type="submit" label="Continue"></p-button>
        </div>
    </form>
</div>